import { render, staticRenderFns } from "./InputPhone.vue?vue&type=template&id=68e8e966&scoped=true&"
import script from "./InputPhone.vue?vue&type=script&lang=js&"
export * from "./InputPhone.vue?vue&type=script&lang=js&"
import style0 from "./InputPhone.vue?vue&type=style&index=0&id=68e8e966&prod&lang=scss&scoped=true&"
import style1 from "./InputPhone.vue?vue&type=style&index=1&id=68e8e966&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e8e966",
  null
  
)

export default component.exports